<template>
  <span>
    <template v-if="taxon.name">
      Quickly grab all the {{ taxon.name }} you need and add them
    </template>
    <template v-else>
      Select a product category below and quickly add what you need
    </template>
  </span>
</template>

<script>
  export default {
    props: {
      taxon: {
        type: Object, required: true
      }
    }
  }
</script>
